import React, { useEffect, useState, Suspense } from "react";
import { Switch, Route, withRouter } from "react-router-dom";

import Blog from "routes/blog";
import Colab from "routes/colab";
import BlogArticle from "routes/blog-article";
import Nav from "components/new-nav";
import Event from "routes/evenement";
import Loader from "components/loader";
import MobilNav from "components/mobile-nav";
import GlobalFonts from "fonts/font";
import Container from "components/container";
import Home from "routes/home";
import Footer from "components/footer";
import Auth from "routes/auth";
import ScrollToTop from "components/scroll-to-top";
import { AuthContext } from "context/authContext";
import { useAuth } from "hooks/useAuth";
//import Apropos from "routes/a-propos";
//import Admin from "routes/admin";
//import Comites from "routes/comites";
//import Teams from "routes/teams";

const Admin = React.lazy(() => import("routes/admin"));
const Apropos = React.lazy(() => import("routes/a-propos"));
const Comites = React.lazy(() => import("routes/comites"));
const Teams = React.lazy(() => import("routes/teams"));

const App = withRouter(({ location }) => {
  const { token, login, logout, userId } = useAuth();
  const mediaMatch = window.matchMedia("(min-width: 1114px)");
  const [matches, setMatches] = useState(mediaMatch.matches);
  useEffect(() => {
    const handler = (e) => setMatches(e.matches);
    mediaMatch.addListener(handler);
    return () => mediaMatch.removeListener(handler);
  }, [mediaMatch]);
  //      <Loader />
  let routes;
  if (token) {
    routes = (
      <Switch>
        <Route exact path="/">
          <Home />
        </Route>
        <Route path="/Apropos">
          <Apropos />
        </Route>
        <Route path="/Comités">
          <Comites />
        </Route>
        <Route path="/Teams">
          <Teams />
        </Route>
        <Route exact path="/Articles">
          <Blog />
        </Route>
        <Route path="/Articles/:title">
          <BlogArticle />
        </Route>
        <Route path="/Login">
          <Auth />
        </Route>
        <Route path="/Collaborateurs">
          <Colab />
        </Route>
        <Route path="/Evenements">
          <Event />
        </Route>
        <Route path="/administration">
          <Admin />
        </Route>
      </Switch>
    );
  } else {
    routes = (
      <Switch>
        <Route exact path="/">
          <Home />
        </Route>
        <Route path="/Apropos">
          <Apropos />
        </Route>
        <Route path="/Comités">
          <Comites />
        </Route>
        <Route path="/Teams">
          <Teams />
        </Route>
        <Route exact path="/Articles">
          <Blog />
        </Route>
        <Route path="/Articles/:title">
          <BlogArticle />
        </Route>
        <Route path="/Login">
          <Auth />
        </Route>
        <Route path="/Collaborateurs">
          <Colab />
        </Route>
        <Route path="/Evenements">
          <Event />
        </Route>
      </Switch>
    );
  }
  let header = matches ? <Nav /> : <MobilNav />;
  return (
    <AuthContext.Provider
      value={{
        isLoggedIn: !!token,
        token: token,
        userId: userId,
        login: login,
        logout: logout,
      }}
    >
      <div className="App" style={{ backgroundColor: "#e5e5e5" }}>
        <ScrollToTop />
        <GlobalFonts />
        {location.pathname.includes("administration") ||
        location.pathname.includes("Administration")
          ? null
          : header}
        <Container>
          <Suspense fallback={<Loader />}>
            <div className="App">{routes}</div>
          </Suspense>
        </Container>
        {location.pathname.includes("administration") ||
        location.pathname.includes("Administration") ? null : (
          <Footer />
        )}
      </div>{" "}
    </AuthContext.Provider>
  );
});

export default App;
